<template>
  <div class="result-wrap">
    <template v-if="!loading">
      <NoticeBar
        v-if="$store.getters.getIsPreview && $store.getters.getIsPreview === 1"
        background="#FFF6EF"
        color="#FA964E"
        text="提示：当前为预览页面，答案不被记录"
      />
      <div class="result" :class="[isPkSuccess ? 'success' : 'fail']"></div>
      <div class="infos">
        <h1 class="infos-text animate__animated animate__fadeInDown">
          {{ tipText }}
        </h1>
        <!-- <p v-if="isPkSuccess" class="scroll-tip">积分+10</p> -->
        <!-- 表头 -->
        <div class="rank-wrap animate__animated animate__fadeInDown">
          <div class="table-title rank-row rank-row-1">
            <div class="rank-col-1">排名</div>
            <div class="rank-col-2">正确题数</div>
            <div class="rank-col-2">总分</div>
          </div>

          <div v-for="(item, index) in rankList" class="rank-row table-content">
            <div class="rank-col-1">
              <span class="order">{{ index + 1 }}</span>
              <img class="avator" :src="item.avatar" alt="" />
              <p class="text van-ellipsis">{{ item.nickname }}</p>
            </div>
            <div class="rank-col-2">{{ item.count }}</div>
            <div class="rank-col-2">{{ item.score || '--' }}</div>
          </div>
        </div>
      </div>
      <!--  试题学习结果隐藏回顾和再次  -->
      <div
        class="button-list"
        :class="{
          'btn-center': $store.getters.getQuesSetting.backStatus !== 2,
        }"
      >
        <Button
          v-if="$store.getters.getQuesSetting.backStatus === 2"
          @click="handlePriviewClick"
          class="button-item"
          plain
          type="primary"
          >试卷回顾</Button
        >
        <Button
          @click="handleJump2Home('again')"
          class="button-item"
          plain
          type="primary"
          >再次PK</Button
        >
      </div>
      <img
        v-if="resInfo.lotteryUrl"
        @click="handleLotteryClick"
        class="gifts animate__animated animate__fadeIn"
        src="@/assets/img/gifts.png"
        alt=""
      />
      <Button
        :class="{ gifts: !resInfo.lotteryUrl }"
        @click="handleJump2Home"
        class="finish-btn"
        >完成</Button
      >

      <!-- 证书弹窗 -->
      <CertificateDialog
        v-if="showCertificate"
        @close="showCertificate = false"
      />
    </template>
    <Loading class="center" color="#2faeff" v-else type="spinner"></Loading>
  </div>
</template>

<script setup>
import { Button, NoticeBar, Dialog, Loading } from 'vant'
import { computed, onMounted, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import qs from 'qs'
import { useCommonReviewQuesEffect } from '@/effects/reviewQuesEffect'
import { useCommonLotteryEffect } from '@/effects/lotteryClickEffect'
import { useCommonGetSubmitCount } from '@/effects/submitEffect'
import { getResult } from '@/api/index'
import CertificateDialog from '@/components/certificateDialog/index.vue'
import { useCertificateDialog } from '@/hooks/index.js'

import successBg from '@/assets/img/pk/success-result.png'
import failBg from '@/assets/img/pk/fail-result.png'

const route = useRoute()
const router = useRouter()
const store = useStore()

const robotCount = parseInt(route.query.robotCount) || 0
const rightCount = parseInt(route.query.rightCount) || 0

const robot = computed(() => {
  return store.getters?.getRobot
})

const user = computed(() => {
  return store.getters?.getUser
})

// 答题结果信息
const resInfo = reactive({
  score: '',
  rank: '',
  rightCount: 0,
  rowNum: 0,
  total: 0,
  totalCount: 0,
  totalScore: 0,
  lotteryUrl: '',
})

// 是否pk成功, 用户答对的题目数大于机器人答对的题目数 || 用户答完全部题目
const isPkSuccess = computed(() => {
  return rightCount > robotCount || rightCount === resInfo.totalCount
})

// 排位列表
const rankList = computed(() => {
  const quesScore = resInfo.totalScore
    ? resInfo.totalScore / resInfo.totalCount
    : 0

  const list = [
    {
      count: `${resInfo.rightCount}/${resInfo.totalCount}`,
      score: resInfo.score,
      ...user.value,
    },
    {
      count: `${robotCount}/${resInfo.totalCount}`,
      score: quesScore * robotCount,
      ...robot.value,
    },
  ]

  return isPkSuccess.value ? list : list.reverse()
})

// 结果背景图
const resultTipBg = computed(() => {
  return `no-repeat center/100% url(${isPkSuccess.value ? successBg : failBg})`
})

const tipText = computed(() => {
  if (isPkSuccess.value) {
    return '恭喜您，挑战成功！'
  } else {
    return '很遗憾，挑战失败！'
  }
})
const loading = ref(true)

const getResultInfo = async () => {
  try {
    const res = await getResult(
      qs.stringify({
        questionActiveKey: route.query.questionActiveKey,
        answerGroupKey: route.query.answerGroupKey,
        type: parseInt(route.query.resultType),
        token: store.getters.getToken,
      })
    )
    if (res.ok) {
      resInfo.score = res.data.score
      resInfo.rank = res.data.rank
      resInfo.rightCount = res.data.rightCount
      resInfo.rowNum = res.data.rowNum
      resInfo.total = res.data.total
      resInfo.totalScore = res.data.totalScore
      resInfo.totalCount = res.data.totalCount
      resInfo.lotteryUrl = res.data.lotteryUrlNew || res.data.lotteryUrl
      // 张店临时造假数据
      if (
        store.getters.getOrgId === '101' &&
        route.query.questionActiveKey === 'ad0158e9bdc0487b8dd6acd0fb7d1bea'
      ) {
        resInfo.total += 24000
      }
    } else {
      if (res.comment === '系统异常') {
        console.log('res.comment', res.comment)
      } else {
        Dialog({ message: res.comment })
      }
    }
    loading.value = false
  } catch (e) {
    loading.value = false

    console.log(e)
  }
}

// 证书弹窗
const { showCertificate } = useCertificateDialog()

onMounted(() => {
  getResultInfo()
})

// 获取答题次数
const { isLimit } = useCommonGetSubmitCount()

// 再次答题
const handleJump2Home = (type) => {
  if (route.query.isSetting) {
    return
  }

  if (type === 'again' && !isLimit.value) {
    Dialog({ message: '已超过次数限制' })
    return
  }
  window.history.length > 1
    ? router.go(-1)
    : router.push({
        path: '/',
        query: route.query,
      })
}

// 试卷回顾点击
const { handlePriviewClick } = useCommonReviewQuesEffect()

// 抽奖点击
const { handleLotteryClick } = useCommonLotteryEffect(resInfo)
</script>
<style lang="scss" scoped>
.result-wrap {
  box-sizing: border-box;
  padding-top: 58px;
  min-height: 100vh;
}
.result {
  margin: 0 auto;
  width: 348px;
  height: 310px;
  text-align: center;
}

.success {
  background: no-repeat center/100%
    url('../../assets/img/pk/success-result.png');
}

.fail {
  background: no-repeat center/100% url('../../assets/img/pk/fail-result.png');
}

.success {
  width: 348px;
  height: 310px;
}

.fail {
  width: 390px;
  height: 306px;
}

.infos {
  margin: 0 30px;
  text-align: center;

  .infos-text {
    margin: 0;
    margin-top: 36px;
    font-size: 36px;
    font-weight: bold;
    color: #333333;
  }

  .scroll-tip {
    margin-top: 20px;
    font-size: 32px;
    font-weight: bold;
    color: #0677f5;
  }

  .rank-wrap {
    margin-top: 36px;
    width: 672px;
    background: #ffffff;
    border-radius: 20px;
    border: 2px solid #e0e0e0;

    .rank-row {
      display: flex;
      align-items: center;
      height: 108px;
      font-size: 32px;
      color: #333333;

      .rank-col-1 {
        display: flex;
        align-items: center;
        width: 50%;
        padding-left: 32px;

        .order {
          margin-right: 18px;
          font-size: 32px;
          color: #333333;
        }

        img.avator {
          margin-right: 18px;
          width: 50px;
          height: 50px;
          border-radius: 50%;
        }
      }

      .rank-col-2 {
        width: 25%;
      }
    }

    .rank-row-1 {
      font-size: 28px;
      font-weight: bold;
      color: #666666;
      // background: linear-gradient(180deg, rgba(202, 236, 255, 0.6) 0%, rgba(255, 255, 255, 0.5) 100%);
    }
  }
}

.button-list {
  display: flex;
  justify-content: space-between;
  margin: 35px 46px;

  .button-item {
    width: 300px;
    height: 80px;
    border: 1px solid #3795ff;
    border-radius: 5px;
    font-size: 34px;
    font-weight: 500;
    color: #3795ff;
  }
}

.btn-center {
  justify-content: center;
}

.gifts {
  display: block;
  margin: 0 auto;
  width: 689px;
  height: 210px;
}

.finish-btn {
  margin: 0 auto;
  margin-top: 136px;
  display: block;
  width: 700px;
  height: 88px;
  background: linear-gradient(-90deg, #388fff 0%, #2faeff 100%);
  border-radius: 44px;
  font-size: 34px;
  font-weight: 500;
  color: #ffffff;
}

.gifts {
  margin-top: 30px;
}
</style>
